import React from 'react';
import { Unstable_Grid2 as Grid, CircularProgress, Typography } from '@mui/material';
import { useQuery } from '@apollo/client';
import { GET_PROFILE } from 'services/graphql/queries';
import { ProfileQuery, ProfileQueryVariables } from 'types/queries';
import DetailsCard from './components/DetailsCard';
import LinkCard from './components/LinkCard';

const CLIENT_APP_LINK = 'https://app.resolvvi.com';

const Details = ():JSX.Element => {
  const { data, loading } = useQuery<ProfileQuery, ProfileQueryVariables>(GET_PROFILE);

  const profile = data?.profile;
  const link = profile?.link?.split('?')[1];
  const currentLink = link ? `${CLIENT_APP_LINK}/elegibilidade?${link}` : '';

  if (loading) return <CircularProgress />;

  return (
    <Grid container spacing={3} direction="column">
      <Grid xs={12}>
        <Typography variant="h6" fontWeight={600} color="textSecondary">
          Meus dados
        </Typography>
      </Grid>
      <Grid xs={12} md={10} lg={8} xl={6}>
        <DetailsCard profile={profile} />
      </Grid>
      <Grid xs={12} md={10} lg={8} xl={6}>
        <LinkCard currentLink={currentLink} />
      </Grid>
    </Grid>
  );
};

export default Details;
